<div class="ccm-overlay" (click)="cerrar()">
  <div class="ccm" (click)="$event.stopPropagation()">
    <header class="ccm-head">
      <h2>Nueva campa&ntilde;a de bonos</h2>
      <p class="ccm-sub">
        Nace en <b>borrador</b>: crear no habilita nada. Alguien la tiene que activar.
      </p>
    </header>

    <div class="ccm-cargando" *ngIf="cargando">Leyendo el cat&aacute;logo&hellip;</div>
    <div class="ccm-error" *ngIf="error">{{ error }}</div>

    <div class="ccm-body" *ngIf="!cargando && !error">
      <!-- Identificación -->
      <div class="ccm-fila">
        <label class="ccm-campo">
          <span>Nombre interno</span>
          <input
            type="text"
            maxlength="120"
            [(ngModel)]="nombre"
            placeholder="Bienvenida Chile septiembre"
          />
          <small>Es el que ves en tu listado. No se publica.</small>
        </label>

        <label class="ccm-campo">
          <span>C&oacute;digo p&uacute;blico</span>
          <input
            type="text"
            maxlength="24"
            [(ngModel)]="codigo"
            placeholder="AGUACATE10"
            class="mono"
          />
          <small *ngIf="!errorCodigo && codigoNormalizado">
            Va a la pieza gr&aacute;fica as&iacute;:
            <b class="mono">{{ codigoNormalizado }}</b>
          </small>
          <small *ngIf="!codigo.trim()">
            S&oacute;lo letras y n&uacute;meros: uno con guiones se tipea mal.
          </small>
          <small class="mal" *ngIf="errorCodigo">{{ errorCodigo }}</small>
        </label>
      </div>

      <!-- Alcance: el primero de los dos ejes -->
      <div class="ccm-bloque">
        <span class="ccm-titulo">&iquest;A qui&eacute;n le paga?</span>
        <div class="ccm-chips">
          <button
            *ngFor="let a of alcances"
            type="button"
            [class.on]="alcanceCodigo === a.alcance"
            (click)="elegirAlcance(a.alcance)"
          >
            {{ alcanceTexto(a) }}
          </button>
        </div>
        <small class="ccm-pista">
          El <b>pa&iacute;s</b> de los clientes que pueden cobrar este bono, seg&uacute;n el
          documento con el que se registraron. Eleg&iacute;lo primero: las monedas
          disponibles dependen de &eacute;l &mdash; un pa&iacute;s solo puede pagar en su
          moneda o en USDT; los dos juntos, s&oacute;lo en USDT.
        </small>
      </div>

      <!-- Moneda: sale del alcance, así que no puede ser una imposible -->
      <div class="ccm-bloque" *ngIf="alcanceCodigo">
        <span class="ccm-titulo">Moneda del bono</span>
        <div class="ccm-chips">
          <button
            *ngFor="let m of monedas"
            type="button"
            class="mono"
            [class.on]="moneda === m"
            (click)="elegirMoneda(m)"
          >
            {{ m }}
          </button>
        </div>
        <small class="ccm-pista">
          Son las &uacute;nicas que sirven para este alcance: USDT siempre, m&aacute;s la
          moneda local si ese alcance tiene una. Con los dos pa&iacute;ses juntos queda
          s&oacute;lo USDT, porque no hay una moneda local que sirva para los dos.
        </small>

        <p class="ccm-aviso" *ngIf="monedaSinCamino">
          <b>{{ moneda }} todav&iacute;a no tiene camino de pago.</b> La campa&ntilde;a se
          puede crear y programar, pero sus reclamos se van a rechazar hasta que exista el
          asiento en esa moneda. Conviene saberlo ahora y no con el primer cliente adentro.
        </p>
      </div>

      <!-- Público: el segundo eje -->
      <div class="ccm-bloque">
        <span class="ccm-titulo">&iquest;A cu&aacute;les de ellos?</span>
        <div class="ccm-chips">
          <button
            *ngFor="let p of publicos"
            type="button"
            [class.on]="alcancePublico === p"
            (click)="elegirPublico(p)"
          >
            {{ publicoTexto(p) }}
          </button>
        </div>

        <small class="ccm-pista">
          Qu&eacute; clientes de ese pa&iacute;s califican:
          <b>todos</b>, los <b>nuevos</b> que nunca hicieron un env&iacute;o &mdash;el bono
          de bienvenida&mdash; o los <b>inactivos</b>, que enviaron alguna vez y dejaron
          de hacerlo. Los dos &uacute;ltimos son excluyentes: quien nunca envi&oacute; no
          es un inactivo, es un nuevo.
        </small>

        <label class="ccm-campo angosto" *ngIf="alcancePublico === 'INACTIVO'">
          <span>D&iacute;as sin enviar para contar como inactivo</span>
          <input type="number" min="1" max="3650" [(ngModel)]="inactivoDias" />
          <small>
            Con 0 d&iacute;as ser&iacute;a una campa&ntilde;a para todos con otro nombre.
          </small>
        </label>
      </div>

      <!-- La plata -->
      <div class="ccm-bloque">
        <span class="ccm-titulo">La plata</span>
        <small class="ccm-pista">
          El monto de cada bono por la cantidad de bonos da la <b>bolsa</b>: el
          m&aacute;ximo que esta campa&ntilde;a puede llegar a costar. Es el n&uacute;mero
          que se autoriza al activarla.
        </small>
        <div class="ccm-fila">
          <label class="ccm-campo">
            <span>Monto de un bono</span>
            <input
              type="text"
              inputmode="decimal"
              [(ngModel)]="monto"
              [placeholder]="moneda === 'USDT' ? '5' : '5000'"
            />
            <small *ngIf="!errorMonto">
              Lo que recibe <b>cada</b> cliente que reclame el bono.
              <ng-container *ngIf="moneda">
                En <b class="mono">{{ moneda }}</b>, hasta {{ decimales }} decimales.
              </ng-container>
            </small>
            <small class="mal" *ngIf="errorMonto">{{ errorMonto }}</small>
          </label>

          <label class="ccm-campo">
            <span>Cu&aacute;ntos bonos</span>
            <input type="number" min="1" max="100000" [(ngModel)]="unidadesTotal" />
            <small>
              Cu&aacute;ntas personas pueden cobrarlo. Es el cupo: cuando se agota, la
              campa&ntilde;a deja de pagar aunque siga vigente.
            </small>
          </label>
        </div>

        <!-- La bolsa es el número que se autoriza al activar, así que se
             muestra grande y calculado, no se deja para que alguien lo estime. -->
        <div class="ccm-bolsa" *ngIf="bolsa">
          <span class="l">Bolsa m&aacute;xima de la campa&ntilde;a</span>
          <span class="n">{{ legible(bolsa) }} <em class="mono">{{ moneda }}</em></span>
          <span class="h">{{ unidadesTotal }} bonos de {{ legible(monto) }}</span>
        </div>

        <p class="ccm-aviso dim" *ngIf="necesitaSegundaFirma">
          Con esta bolsa, activar la campa&ntilde;a va a necesitar un
          <b>segundo operador</b>: quien la crea no la activa.
        </p>
      </div>

      <!-- Vigencia -->
      <div class="ccm-bloque">
        <span class="ccm-titulo">Vigencia</span>
        <div class="ccm-fila">
          <label class="ccm-campo">
            <span>Desde</span>
            <input type="date" [(ngModel)]="vigenciaDesde" />
            <small>Arranca a las 00:00 de ese d&iacute;a.</small>
          </label>
          <label class="ccm-campo">
            <span>Hasta</span>
            <input type="date" [(ngModel)]="vigenciaHasta" />
            <small>Incluye ese d&iacute;a completo, hasta las 23:59.</small>
          </label>
        </div>
        <small class="mal" *ngIf="errorFechas">{{ errorFechas }}</small>
        <small class="ccm-pista" *ngIf="arrancaDespues && !errorFechas">
          Arranca en el futuro: al activarla queda <b>programada</b> y se enciende sola
          ese d&iacute;a.
        </small>
      </div>

      <!-- Cómo y cuándo se paga -->
      <div class="ccm-bloque">
        <span class="ccm-titulo">&iquest;Cu&aacute;ndo se acredita?</span>
        <div class="ccm-chips">
          <button
            *ngFor="let c of condiciones"
            type="button"
            [class.on]="condicionAcreditacion === c"
            (click)="condicionAcreditacion = c"
          >
            {{ condicionTexto(c) }}
          </button>
        </div>
        <small class="ccm-pista">
          Con condici&oacute;n diferida el bono queda <b>retenido</b>: se reserva la
          unidad y se paga cuando el cliente cumpla. Si no cumple antes de que venza la
          reserva, la unidad vuelve al cupo.
        </small>

        <label class="ccm-campo angosto">
          <span>D&iacute;as que vive la reserva</span>
          <input type="number" min="1" max="365" [(ngModel)]="reservaDias" />
          <small>
            Cu&aacute;nto tiempo tiene el cliente para cumplir la condici&oacute;n antes
            de que el bono venza y su unidad vuelva al cupo. S&oacute;lo aplica si la
            acreditaci&oacute;n no es inmediata. Vac&iacute;o usa 15 d&iacute;as.
          </small>
        </label>
      </div>

      <!-- El freno -->
      <div class="ccm-bloque">
        <span class="ccm-titulo">Freno autom&aacute;tico</span>
        <small class="ccm-pista">
          Si en la ventana se reclama m&aacute;s de ese porcentaje del cupo, la
          campa&ntilde;a se pausa sola y avisa. Se cuenta sobre <b>bonos tomados</b>, no
          sobre intentos: si contara intentos, cualquiera podr&iacute;a apagar una
          campa&ntilde;a tipeando c&oacute;digos mal.
        </small>
        <div class="ccm-fila">
          <label class="ccm-campo">
            <span>% del cupo</span>
            <input type="number" min="1" max="100" [(ngModel)]="pausaPct" />
            <small>Qu&eacute; porci&oacute;n del cupo puede irse antes de frenar.</small>
          </label>
          <label class="ccm-campo">
            <span>en minutos</span>
            <input type="number" min="1" max="1440" [(ngModel)]="pausaMinutos" />
            <small>La ventana en la que se cuenta ese porcentaje.</small>
          </label>
        </div>
        <small class="ccm-pista">
          Vienen de la configuraci&oacute;n del m&oacute;dulo, as&iacute; que ninguna
          campa&ntilde;a queda sin freno por olvido.
        </small>
      </div>
    </div>

    <footer class="ccm-acciones" *ngIf="!cargando && !error">
      <button class="ccm-guardar" [disabled]="!puedeGuardar" (click)="guardar()">
        {{ guardando ? 'Creando…' : 'Crear en borrador' }}
      </button>
      <button class="ccm-cancelar" (click)="cerrar()">Cancelar</button>
    </footer>
  </div>
</div>
